import { getSurveyAnswers } from "src/hooks/survey/answers";

import { updateCurrentAnswers } from "@utils/redux/slices/currentAnswers";
import { addSurveyAnswers } from "@utils/redux/slices/surveyAnswers";
import { shouldPreselectMedicareOnHealthInsuranceProvider } from "@utils/userSegment/features";

import { getPageSetSurvey } from "./util";
import { ActionHandlerParams } from "..";

const questionId = "healthInsuranceProvider";

export const seedMedicareOnHealthInsuranceProvider = async ({
  store,
  pageSet,
  page,
}: ActionHandlerParams): Promise<void> => {
  if (!shouldPreselectMedicareOnHealthInsuranceProvider()) {
    return;
  }

  const surveyAnswers = getSurveyAnswers();
  const existingAnswer = surveyAnswers[questionId];
  if (Array.isArray(existingAnswer) && existingAnswer[0] === "medicare") {
    return;
  }

  const survey = getPageSetSurvey(pageSet, page);
  const answers = {
    [questionId]: ["medicare"],
    hasMedicare: true,
  };

  store.dispatch(addSurveyAnswers(answers));
  store.dispatch(
    updateCurrentAnswers({
      namespace: survey.surveyNameSpace,
      answers,
    })
  );
};
